module.exports = __webpack_public_path__ + "assets/3d6c2af0ba5c2a504b359ba7eff53cb3.png";